import { dashboardModule } from "@/store/loyalty/dashboardModule";
import { segmentationModule } from "@/store/loyalty/segmentationModule";
import { rfmModule } from "@/store/loyalty/rfmModule";
import { marketingGuests } from "@/store/loyalty/marketingGuestsModule"
import { marketingLoyalty } from "@/store/loyalty/marketingLoyaltyModule"
import { marketingLastOrders } from "@/store/loyalty/marketingLastOrdersModule"
import { favouriteProducts } from "@/store/loyalty/favouriteProductsModule"
import { reportPromocodesModule } from "@/store/loyalty/reportPromocodesModule";
import { reportFastSetsModule } from "@/store/loyalty/reportFastSetsModule";
import { marketingCertificatesModule } from "@/store/loyalty/marketingCertificatesModule";

export const loyaltyModules = {
    dashboard: dashboardModule,
    segmentation: segmentationModule,
    rfm: rfmModule,
    marketingGuests: marketingGuests,
    marketingLoyalty: marketingLoyalty,
    marketingLastOrders: marketingLastOrders,
    favouriteProducts: favouriteProducts,
    reportPromocodes: reportPromocodesModule,
    reportFastSets: reportFastSetsModule,
    marketingCertificates: marketingCertificatesModule
}